import {Brick, registerBrick} from 'olympe';
import {PurchaseRequest} from '../models/PurchaseRequest';

export default class ModifyStatus extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} pRToModify
     * @param {function()} forwardEvent
     * @param {function(string)} setPRModified
     */
    update($, [pRToModify], [forwardEvent, setPRModified]) {
        const parsedPR = new PurchaseRequest(pRToModify);

        parsedPR.status = 'submitted';

        setPRModified(JSON.stringify(parsedPR.getPurchaseRequest()));
        forwardEvent();
    }
}

registerBrick('0189917c181d02978ecd', ModifyStatus);
